module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.skinSearch),
      expression: "skinSearch"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.skinSearch)
    },
    on: {
      "keyup": function($event) {
        _vm.skinSearchDB();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.skinSearch = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-1 col-sm-3"
  }, [_c('a', {
    staticClass: "rename-skins btn btn-danger",
    on: {
      "click": function($event) {
        _vm.rename = !_vm.rename
      }
    }
  }, [_c('i', {
    staticClass: "edit icon"
  }), _vm._v("Change skins name")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.skins.images.length) ? _c('div', {
    staticClass: "ui six stackable cards",
    attrs: {
      "id": "skins-cards"
    }
  }, _vm._l((_vm.skins.visible_images), function(item) {
    return _c('div', {
      class: 'col-sm-6 col-md-4 card col-lg-' + _vm.bigScreenSkins,
      attrs: {
        "data-skin-id": item.id
      }
    }, [_c('img', {
      staticClass: "card-img-top",
      attrs: {
        "src": _vm.baseUrl2 + '/public/images/skins/' + item.skin_name + '.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('div', {
      staticClass: "card-text"
    }, [(_vm.role >= 33) ? _c('span', [_vm._v(_vm._s(item.ip))]) : _vm._e(), _vm._v(" "), (_vm.role >= 33) ? _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(item.approved_by))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [(!_vm.rename) ? _c('h4', {
      staticClass: "text-center card-title mt-3"
    }, [_vm._v(_vm._s(item.skin_name))]) : _c('div', {
      staticClass: "ui bottom attached button chose-skin edit-name"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": item.skin_name
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon",
      on: {
        "click": function($event) {
          _vm.renameSkinDB(item.skin_name, $event.target)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.removeSkinDB(item.id, item.skin_name)
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), (Number(item.safe)) ? _c('button', {
      staticClass: "btn btn-success pull-right btn-sm",
      on: {
        "click": function($event) {
          _vm.safeSkin(item.id, item.skin_name, 0)
        }
      }
    }, [_vm._v("Siguran skin")]) : _vm._e(), _vm._v(" "), (!Number(item.safe)) ? _c('button', {
      staticClass: "btn btn-warning pull-right btn-sm",
      on: {
        "click": function($event) {
          _vm.safeSkin(item.id, item.skin_name, 1)
        }
      }
    }, [_vm._v("Nije siguran")]) : _vm._e()])])
  })) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Skins\n      "), _c('small', [_vm._v("Skin list")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07c42168!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/skins/Index.vue
// module id = 302
// module chunks = 2